import createTableStore from "ds/components/Table/store/useTableStore";

import { FLOWS_PROJECTS_COLUMN_CONFIG, FLOWS_PROJECTS_COLUMNS_STORAGE_KEY } from "./constants";

const useFlowsProjectsTableStore = createTableStore({
  storageKey: FLOWS_PROJECTS_COLUMNS_STORAGE_KEY,
  config: FLOWS_PROJECTS_COLUMN_CONFIG,
});

export default useFlowsProjectsTableStore;
